import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface DocumentosCambioGestionPayload {
  codigo: string;
  version: string;
  fecha_designacion: string;
  fecha_vencimiento: string;
  motivo_creacion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface DocumentosCambioGestion {
  id?: number;
  codigo: string;
  version: string;
  fecha_designacion: string;
  fecha_vencimiento: string;
  motivo_creacion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

/**
 * 🔹 Respuesta genérica
 */
export interface DocumentosCambioGestionResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class DocumentosCambioGestionService {
  private readonly apiUrl = `${environment.apiUrl}/api/documentos_cambio_gestion`;

  constructor(private http: HttpClient) {}

  // Obtener todos los documentos
  getAll(): Observable<DocumentosCambioGestion[]> {
    return this.http.get<DocumentosCambioGestion[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  // Obtener por ID
  getById(id: number): Observable<DocumentosCambioGestion> {
    return this.http.get<DocumentosCambioGestion>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Crear documento
  create(
    payload: DocumentosCambioGestionPayload
  ): Observable<DocumentosCambioGestionResponse> {
    return this.http.post<DocumentosCambioGestionResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Actualizar documento
  update(
    id: number,
    payload: Partial<DocumentosCambioGestionPayload>
  ): Observable<DocumentosCambioGestionResponse> {
    return this.http.put<DocumentosCambioGestionResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Eliminar documento
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Inactivar documento
  inactivar(id: number): Observable<DocumentosCambioGestionResponse> {
    return this.http.put<DocumentosCambioGestionResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  // Activar documento
  activar(id: number): Observable<DocumentosCambioGestionResponse> {
    return this.http.put<DocumentosCambioGestionResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}